import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./ApplicantDetailsSkeleton.module.scss";

const ApplicantDetailsSkeleton = () => {
  return (
    <div className={styles.pageContainer}>
      {/* Profile section */}
      <div className={styles.profileSection}>
        <div className={styles.avatar}>
          <Skeleton circle height="100%" width="100%" />
        </div>
        <div className={styles.profileText}>
          <Skeleton height={15} width="60%" />
          <Skeleton height={15} width="60%" />
          <Skeleton height={15} width="60%" />
        </div>
      </div>

      {/* Content cards */}
      <div className={styles.cardGrid}>
        {[1, 2, 3, 4].map((_, i) => (
          <div key={i}>
            <Skeleton height={150} />
            <Skeleton height={20} width="90%" />
            <Skeleton height={20} width="60%" />
          </div>
        ))}
      </div>
    </div>
  );
};



export default ApplicantDetailsSkeleton;
